import React from 'react'
import { Box } from '@mui/material'
import {
  hamburgerBoxSx,
  hamburgerButtonSx,
} from '@/layout-blueprints/chromeComponentSx'

export default function HamburgerButton({
  active = false,
  showBelowMl = false,
  mobileOnly = false,
  onClick,
  id,
  className,
  'aria-label': ariaLabel = 'Toggle sidebar',
  sx,
}) {
  return (
    <Box
      component="button"
      type="button"
      id={id}
      className={className}
      aria-label={ariaLabel}
      onClick={onClick}
      sx={[hamburgerButtonSx({ active, showBelowMl, mobileOnly  }), sx]}
    >
      <Box sx={hamburgerBoxSx}>
        <Box data-hf="hamburger-inner" />
      </Box>
    </Box>
  )
}
